<template>
  <div>
    <v-select
      outlined
      dense
      v-model="selectedNode.settings.action"
      :items="actionMethods"
      @change="(val) => onUpdate(val, 'settings.action')"
      item-text="label"
      item-value="value"
      label="Action"
      style="margin-bottom: 15px"
    ></v-select>
    <v-select
      outlined
      dense
      v-model="selectedNode.settings.keyToStoreOrGet"
      :items="availableInputFields"
      @change="(val) => onUpdate(val, 'settings.keyToStoreOrGet')"
      item-text="name"
      item-value="name"
      label="Key To Store Or Get"
      style="margin-bottom: 15px"
    ></v-select>
    <v-select
      outlined
      dense
      v-if="selectedNode.settings.action === 'set'"
      v-model="selectedNode.settings.valueToStore"
      :items="availableInputFields"
      @change="(val) => onUpdate(val, 'settings.valueToStore')"
      item-text="name"
      item-value="name"
      label="Value To Store"
      style="margin-bottom: 15px"
    ></v-select>
    <v-text-field
      outlined
      dense
      v-model="selectedNode.settings.ttl"
      label="Expires after (in hours. Max 24h)"
      hide-details="auto"
      min="1"
      max="24"
      step="1"
      type="number"
    ></v-text-field>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters: workflowDetailsGetters } =
  createNamespacedHelpers('workflows/details');

export default {
  name: 'breakpoint-settings',
  computed: {
    ...workflowDetailsGetters({
      selectedNode: 'SELECTED_NODE',
    }),
  },
  props: {
    availableInputFields: { required: true },
  },
  data() {
    return {
      actionMethods: [
        {
          value: 'set',
          label: 'Store Content',
        },
        {
          value: 'get',
          label: 'Get Content',
        },
      ],
    };
  },
  methods: {
    onUpdate(value, path) {
      this.$emit('update', value, path);
    },
  },
};
</script>

<style scoped lang="scss"></style>
